/* eslint-disable no-restricted-imports */
import React, {useEffect, useMemo} from "react";
import { Modal} from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  AEInput,
  ModalProgressBar, Pagination
} from "../../../../_metronic/_partials/controls";
import { useModuleContext } from "../ModuleContext";
import {AEButton} from "../../../../_emywork/components/buttons";
import {useFormik} from "formik";
import {actionTypes} from "../../EmyProjects/_redux/slice";
import {invitesActionTypes} from "../../EmyProjects/_redux/invites/slice";
import * as actions from "../../EmyProjects/_redux/actions";
import * as invitesActions from "../../EmyProjects/_redux/invites/actions";
import {HTTP_CREATED, HTTP_UPDATED} from "../../../../_emywork/helpers/AxiosHelpers";
import {useIntl} from "react-intl";
import {useMetadata} from "../../../../_emywork/AEPagination";
import {AELabel} from "../../../../_emywork/components/AELabel";
import {EntityCard} from "../../EmyProjects/componants/EntityCard";
import {ModuleProvider} from "../../EmyProjects/ModuleContext";


export function HireModal() {
  const UIContext = useModuleContext();
  const dispatch = useDispatch();
  const {formatMessage} = useIntl();

  const {authProposal, entities, isLoading, meta} = useSelector( (s) => {
    const {entities, isLoading, meta} = s.emy_projects[actionTypes.HireModalList];
    const {proposal: authProposal} = s.auth;

    return { authProposal, entities, isLoading, meta }
  }, shallowEqual );

  const metadata = useMetadata(meta);
  const { page, perPage, sortAsc, filters, sortField, select, setPerPage, setFilters, total } = metadata;
  const formik = useFormik({
    initialValues: {
      ...filters
    },
    onSubmit: (values)=>{
      setFilters(values)
    }
  });

  const {show, close, id} = useMemo(() => {
    return {
      show: UIContext.hireModalShow,
      close: UIContext.closeHireDialog,
      id: UIContext.idForHire,
    };
  }, [UIContext]);

  // looking for loading/dispatch
  useEffect(() => {
    if(id){
      let m = metadata.toAEMetadata();
      m.filters.proposal_id = authProposal.id
      dispatch(
        actions.fetchEntities(m, actionTypes.HireModalList)
      )
    }

  }, [id, authProposal, dispatch, filters, page, perPage,]);

  useEffect(() => {
    formik.handleSubmit()
  }, [formik.values.search]);



  return (
    <Modal size={'lg'} show={show} onHide={close} >
      {isLoading && <ModalProgressBar variant="query" />}
      <Modal.Body>
        <AEInput
          borderless
          validation={false}
          withFeedbackLabel={false}
          className={"form-control-solid"}
          field={formik.getFieldProps('search')}
          form={formik}
          name={"search"}
          label={"SEARCH"}
        />

        <div
          className="mt-7 scroll scroll-pull"
          // style={{maxHeight: 400}}
        >
          <ModuleProvider>
            {
              !isLoading &&
              entities.map((emyProject, i) => {
                return (
                  <div key={emyProject.id}>
                    <div className={'d-flex justify-content-between align-items-center flex-wrap py-3'}>
                      <div>
                        <EntityCard
                          size={'xs'}
                          entity={emyProject}

                        />
                      </div>
                      <div className={''}>
                        <AEButton
                          variant={'clean'}
                          onClick={() => {
                            dispatch(invitesActions.createEntity(
                              {
                                entity:{
                                  "project_id": emyProject.id,
                                  "proposal_id": id
                                }
                              }
                            ))
                              .then((r) => {
                                if (r.status === HTTP_CREATED) {
                                  close()
                                }
                              })
                          }}
                        >
                          {formatMessage({id: "HIRE"})}
                        </AEButton>
                      </div>
                    </div>
                    {
                      i !== Math.min(total, perPage) - 1 &&
                      <div className="separator separator-solid"/>
                    }

                  </div>
                )
              })
            }
          </ModuleProvider>


          <Pagination {...metadata} className={''}/>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <AEButton variant={'light'} onClick={close} >
          {formatMessage({id:"DONE"})}
        </AEButton>
      </Modal.Footer>
    </Modal>
  );
}
